import React from 'react';
import {useStyles} from "./styles/LoginStyle";
import {
    Box,
    Button,
    Typography,
    TextField,
} from "@material-ui/core";
import clsx from "clsx";
import { ReactComponent as WarningIcon } from '../../../common/images/WarningIcon.svg';
import { ReactComponent as CheckListOff } from '../../../common/images/CheckListOff.svg';
import { ReactComponent as CheckListOn } from '../../../common/images/CheckListOn.svg';
import {inject, observer} from "mobx-react";
import {COMMON_UTIL} from "../../../common/util/common.util";
import {URL_TYPE} from "../../../routes/Routes";
import {useHistory} from "react-router-dom";
import {injectIntl} from "react-intl";


function PwReset(props) {
    const classes = useStyles();
    const history = useHistory();
    const {authStore} = props;
    const {intl} = props;

    const handleChangePassword = (e) => {
        authStore.setNewPassword(e.target.value);
    }

    const handleChangeConfirmPassword = (e) => {
        authStore.setConfirmNewPassword(e.target.value);
    }

    const isPasswordMatch = () => {
        return authStore.newPassword === authStore.confirmNewPassword;
    }

    const verifyPattern = () => {
        const passwordPattern = /[A-Za-z\d\W_]{2,}$/;

        return passwordPattern.test(authStore.newPassword);
    }

    const verifyLength = () => {
        return authStore.newPassword.length > 7;
    }

    const handleResetPassword = () => {
        const authToken = COMMON_UTIL.getUrlParam('token');
        const userId = COMMON_UTIL.getUrlParam('userId');

        authStore.resetPassword(userId, authToken, () => history.push(URL_TYPE.PwResetCompleted));
    }

    return (
        <Box className={classes.root}>
            <Box className={classes.loginBox}>
                <Box className={classes.resetBoxInner}>
                    <Typography className={classes.titleText}>{intl.formatMessage({id: "reset_password"})}</Typography>
                    <Typography className={classes.subText}>{intl.formatMessage({id: "msg_info_enter_new_password"})}</Typography>
                    <form>
                        <Box className={classes.loginResetText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Typography>{intl.formatMessage({id: "password"})}</Typography>
                            <Box className={classes.textLoginBox} >
                                <TextField id="password" variant="outlined" placeholder={intl.formatMessage({id: "password"})} type="password" autoComplete="off" value={authStore.newPassword} onChange={handleChangePassword}/>
                            </Box>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Box className={classes.checkList} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                {verifyPattern() ?
                                    <CheckListOn />
                                    :
                                    <CheckListOff />
                                }
                                <Typography>{intl.formatMessage({id: "msg_info_password_rule1"})}</Typography>
                            </Box>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Box className={classes.checkList} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                {verifyLength() ?
                                    <CheckListOn />
                                    :
                                    <CheckListOff />
                                }
                                <Typography>{intl.formatMessage({id: "msg_info_password_rule2"})}</Typography>
                            </Box>
                        </Box>
                        <Box className={classes.loginResetText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <Typography>{intl.formatMessage({id: "verify_password"})}</Typography>
                            <Box className={classes.textLoginBox} >
                                <TextField id="confirmPassword" variant="outlined" placeholder={intl.formatMessage({id: "password"})} type="password" autoComplete="off" value={authStore.confirmNewPassword} onChange={handleChangeConfirmPassword} />
                            </Box>
                        </Box>
                    </form>
                    {!isPasswordMatch() &&
                        <Box className={classes.noticeText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                            <WarningIcon /><Typography>{intl.formatMessage({id: "msg_info_not_match_password_recheck"})}</Typography>
                        </Box>
                    }
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"} sx={{marginTop: 25}}>
                        <Button style={(!isPasswordMatch() || !verifyPattern() || !verifyLength()) ? {background: '#808287'} : {background: null}} className={clsx(classes.LoginButton, classes.LoginButtonActive)} disabled={!isPasswordMatch() || !verifyPattern() || !verifyLength()} onClick={handleResetPassword} disableRipple>
                            <Typography>{intl.formatMessage({id: "reset_password"})}</Typography>
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default inject('authStore')(injectIntl(observer(PwReset)));
